/*eslint no-unused-vars:0 no-trailing-spaces:0 */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let ProOnly = require("../../../../widgets/ProOnly");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../../utils/FormUtils");
let Constants = require("../../../../../utils/Constants");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");
let getSpeakersFromDisplaylists = require("../../../../../utils/getSpeakersFromDisplaylists");
let AuthedUserSession = require('../../../../../utils/AuthedUserSession');

var IS_ST = !!AuthedUserSession.is_st_family;

let ContactForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValues(props){
		let contact = props.contact;
		if (!contact) {//there can be contacts with an id less than 1 if it's from grab
			return null;
		}
		let data = {
			cname: contact.cname,
			company: contact.company,
			title: contact.title,
			phone: contact.phone,
			mobile: contact.mobile,
			fax: contact.fax,
			email: contact.email,
			address: contact.address,
			city: contact.city,
			st: contact.st,
			country: contact.country,
			zip: contact.zip,
			contnotes: contact.contnotes,
			groupcodes: IS_ST ? contact.groupcodes : _.first(contact.groupcodes),
			externalid: contact.externalid
		};
		let flags = _.parseInt(contact.flags);
		_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
			/*eslint no-bitwise:0 */
			data["flags_" + flag] = (flags & _.parseInt(flag)) > 0;
		});
		return data;
	},
	buildSchema(){
		let data = this.state.data || {};
		let {event, Displaylists} = this.props;
		let speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));

		let schema = {
			cname: {
				label: "Name",
				type: "text",
				validate: FormUtils.v.required
			},
			company: {
				label: "Company",
				type: "text"
			},
			title: {
				label: "Title",
				type: "text"
			},
			phone: {
				label: "Phone",
				type: "text"
			},
			mobile: {
				label: "Mobile",
				type: "text"
			},
			fax: {
				label: "Fax",
				type: "text"
			},
			email: {
				label: "Email",
				type: "text"
			},
			contnotes: {
				label: "Notes",
				type: "textarea"
			},
			groupcodes: {
				label: "Group Code",
				type: IS_ST ? "groupCodeSelect" : "combo",
				options: _.object(_.map(speaker && speaker.contactcodes, function (code, id) {
					return [code, code];
				}))
			},
			online_assistant: {
				type: "select",
				placeholder: "-- select invitation --",
				options: Constants.ONLINE_ASSISTANT_OPTIONS,
				disabled: !data["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS],
				validate: FormUtils.v.optional
			}
		};
		schema = _.assign(FormUtils.buildAddressFields(Displaylists, data), schema);

		_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
			schema["flags_" + flag] = {
				label: desc,
				type: "checkbox"
			};
		});

		if (AuthedUserSession.is_privatelabel) {
			delete schema["flags_" + Constants.CONTACT_CSP];
			delete schema["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS];
			delete schema["online_assistant"];
		}
		return schema;
	},
	__sendOnlineAssistantEmail: esUtils.wrapPreventDefault(function () {
		let {event} = this.props;
		let errors = this.state.errors || {};
		let data = this.state.data || {};
		if (data["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS] && event && event.eid > 0) {
			let recipientemail = data.email;
			let recipientname = data.cname;
			if (!_.isString(recipientemail) || recipientemail.trim().length === 0 || !esUtils.is_valid_email(recipientemail)) {
				errors.email = "Please enter their email";
			}
			if (!_.isString(recipientname) || recipientname.trim().length === 0) {
				errors.cname = "Please enter their name";
			}
			if (!_.has(Constants.ONLINE_ASSISTANT_OPTIONS, data.online_assistant)) {
				errors.online_assistant = "Please select an invitation";
			}
			if (errors.email || errors.cname || errors.online_assistant) {
				if (errors.email || errors.cname) {
					errors.online_assistant = "You must set the contacts name and email first";
				}
				this.setState({errors: errors});
			} else {
				this.props.sendOnlineAssistantEmail(event.eid, recipientemail, recipientname, data.online_assistant);
			}
		}
	}),
	render(){
		let fields = this.Form_buildSchema();
		let errors = this.state.errors || {};
		let {onCancel, onDelete, contact, event} = this.props;
		let is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
		var layout, layout1, layout2;

		if ( this.props.from_parent ) {
			is_limited_speaker = true;
		}

		if ( IS_ST ) {
			layout1 = [
				["cname", "title"],
				["company", "mobile"],
				["phone", "groupcodes"],
				["fax", null]
			];
			layout2 = [
				["email"],
				["address"],
				["city", "st"],
				["zip", "country"],
				["contnotes"]
			];
		} else {
			layout = [
				["cname", "groupcodes"],
				["company", "title"],
				["phone", "mobile"],
				["fax", null],
				["email"],
                ["address"],
                ["city", "st"],
                ["zip", "country"],
				["contnotes"]
			];
		}
		_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
			if (!_.includes([Constants.CONTACT_CSP, Constants.CONTACT_ONLINEOFFICEACCESS], _.parseInt(flag))) {
				if ( IS_ST ) {
					layout2.push(["flags_" + flag]);
				} else {
					layout.push(["flags_" + flag]);
				}
			}
		});

		return dd.form({className: "form-horizontal new-contact-form", onSubmit: this.Form_onSubmit},

			(IS_ST ? dd.div(null,
				ezHorizontalFields(this, layout1),
				dd.div({style: {marginTop: '5px'}}, null),
				ezHorizontalFields(this, layout2)
			) : dd.div(null,
				ezHorizontalFields(this, layout)
			)),

			!AuthedUserSession.is_privatelabel ? ProOnly({sids: event.sids},
				ezHorizontalFields(this, [
					["flags_" + Constants.CONTACT_CSP],
					["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS]
				]),
				dd.div({className: "form-group" + (errors["online_assistant"] ? " has-error" : "")},
					dd.label({className: "control-label col-sm-3"}, " "),
					dd.div({className: "col-sm-6"},
						this.Form_buildInput(fields.online_assistant),
						errors["online_assistant"] ? dd.span({className: "help-block"}, errors["online_assistant"]) : null
					),
					dd.div({className: "col-sm-3"},
						dd.button({
								className: "btn btn-default btn-sm " + (fields.online_assistant.disabled ? "disabled" : ""),
								disabled: fields.online_assistant.disabled ? "disabled" : null,
								onClick: this.__sendOnlineAssistantEmail
							},
							"Send email"
						)
					)
				)
			) : null,
			HorizontalFieldSpot(null,
				(is_limited_speaker) ?
					FormButtons({
						submit_btn_text: 'cancel',
						onSubmit: onCancel,
						onCancel: null,
						onDelete: null,
						right_align: true,
						scale: 'md'
					})
					:
					FormButtons({
						submit_btn_text: contact && contact.id > 0 ? "Save" : "Add New Contact",
						onCancel,
						onDelete: contact && contact.id > 0 ? onDelete : null,
						right_align: true,
                        scale: 'md'
					})
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			Event_notify_contact: {key: "callService"}
		};
	},
	__sendOnlineAssistantEmail(event_id, recipientemail, recipientname, messagetype){
		this.RadioService_callService("Event_notify_contact", {event_id, recipientemail, recipientname, messagetype});
	},
	__onSubmit(data){
		let event = _.cloneDeep(this.props.event);
		let editing_id = this.props.editing_id > 0 ? this.props.editing_id : 0;

		if (editing_id < 1) {
			if (!_.isArray(event.EventContact)) {
				event.EventContact = [];
			}
			event.EventContact.push({id: editing_id, eid: event.eid});
		}
		_.each(event.EventContact, function (contact) {
			if (contact.id == editing_id) {
				contact.cname = data.cname;
				contact.company = data.company;
				contact.title = data.title;
				contact.phone = data.phone;
				contact.mobile = data.mobile;
				contact.fax = data.fax;
				contact.email = data.email;
				contact.address = data.address;
				contact.city = data.city;
				contact.st = data.st;
				contact.zip = data.zip;
				contact.country = data.country;
				contact.contnotes = data.contnotes;
				contact.groupcodes = data.groupcodes;
				contact.externalid = data.externalid;
				contact.flags = 0;
				_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
					if (data["flags_" + flag]) {
						contact.flags += _.parseInt(flag);
					}
				});
			}
		});
		radio("save_Event").broadcast(event);
		this.props.onClose();
	},
	__onDelete: esUtils.wrapPreventDefault(function () {
		let editing_id = this.props.editing_id > 0 ? this.props.editing_id : 0;
		if (editing_id === 0) {
			return;
		}
		let event = _.cloneDeep(this.props.event);
		event.EventContact = _.reject(event.EventContact, function (contact) {
			return contact.id == editing_id;
		});
		radio("save_Event").broadcast(event);
		this.props.onClose();
	}),
	render(){
		let {event, Displaylists, editing_id, contact, onClose} = this.props;
		let ajax = this.state.Event_notify_contact;
		let from_parent = false;

		_.each(event.EventContact, function (elm) {
			if (elm.id == editing_id) {
				contact = elm;
			}
		});
		_.each(event.EventContact_from_parent, function (elm) {
			if (elm.id == editing_id) {
				contact = elm;
				from_parent = true;
			}
		});

		return dd.div(null,
			editing_id < 0 ? null : Modal({
					title: editing_id > 0 ? "Edit Contact" : "New Contact",
					onClose,
					buttons: []
				},
				LoadingWrap({is_loading: !!ajax.waiting, text: "Sending..."},
					ErrorAlert({message: ajax.error}),
					!ajax.data ? null : dd.div({className: "alert alert-success"}, ajax.data),
					ContactForm({
						contact,
						event,
						Displaylists,
						onClose,
						onSubmit: this.__onSubmit,
						onCancel: onClose,
						onDelete: this.__onDelete,
						sendOnlineAssistantEmail: this.__sendOnlineAssistantEmail,
						from_parent: from_parent
					})
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/EditContactModal.js